<template>
  <div>
    <el-tabs v-if="name && formConfig.length > 0" v-model="active">
      <el-tab-pane :label="name" name="properties">
        <component :is="(selectNode.type || '').toLowerCase()" :config="selectNode.props" />
      </el-tab-pane>
      <el-tab-pane label="表单权限设置" name="permissions">
        <form-authority-config />
      </el-tab-pane>
    </el-tabs>
    <component :is="(selectNode.type || '').toLowerCase()" v-else :config="selectNode.props" />
  </div>
</template>

<script>
import Approval from '@/pages/system/workflow/process/config/ApprovalNodeConfig';
import Condition from '@/pages/system/workflow/process/config/ConditionNodeConfig';
import Delay from '@/pages/system/workflow/process/config/DelayNodeConfig';
import Cc from '@/pages/system/workflow/process/config/CcNodeConfig';
import Trigger from '@/pages/system/workflow/process/config/TriggerNodeConfig';
import FormAuthorityConfig from '@/pages/system/workflow/process/config/FormAuthorityConfig';
import Root from '@/pages/system/workflow/process/config/RootNodeConfig';

export default {
  name: 'NodeConfig',
  components: {
    Approval,
    Condition,
    Trigger,
    Delay,
    Root,
    Cc,
    FormAuthorityConfig
  },
  data() {
    return {
      active: 'properties'
    };
  },
  computed: {
    selectNode() {
      return this.$store.state.selectedNode;
    },
    formConfig() {
      return this.$store.state.design.formItems;
    },
    name() {
      switch (this.selectNode.type) {
        case 'ROOT':
          return '设置发起人';
        case 'APPROVAL':
          return '设置审批人';
        case 'CC':
          return '设置抄送人';
        default:
          return null;
      }
    }
  },
  methods: {}
};
</script>

<style lang="less" scoped></style>
